import React from "react"
import BlogLayout from "@talentinc/gatsby-theme-ecom/layouts/BlogLayout"
import { PageContextType, PageDataType } from "@talentinc/gatsby-theme-ecom/types/page"
import BodySection from "@talentinc/gatsby-theme-ecom/components/Blog/Author/BodySection"
import Footer from "@talentinc/gatsby-theme-ecom/components/Footer/Footer"
import { useAuthorContext } from "@talentinc/gatsby-theme-ecom/contexts/AuthorContext"
import AuthorHero from "@talentinc/gatsby-theme-ecom/components/Blog/Author"

export default function AuthorPage({
  pageContext,
  pageData,
}: {
  pageContext: PageContextType
  pageData: PageDataType
}) {
  const { currentPage, numPages, articleByAuthor, authorBySlug } = useAuthorContext()

  return (
    <BlogLayout pageContext={pageContext} pageData={pageData}>
      <AuthorHero authorBySlug={authorBySlug} />
      <BodySection
        articlesData={articleByAuthor || []}
        pagination={{ currentPage, numPages }}
        onSearchSubmit={null}
        noResultText=""
      />
      <Footer />
    </BlogLayout>
  )
}
